// extracted by mini-css-extract-plugin
export default {"textInputLabel":"UT-z","textInput":"VT-z","error":"WT-z","disabled":"XT-z"};